import { ESubInfo, Subcontractor } from "../types";
import { Row, DeleteRowButton } from "../styles";
import Input from "../../../../../components/inputField";
import React, { useState } from "react";
import { StyledQuestion } from "../../styles";
import { FunctionalButton } from "../../../../../components/functionalButton";
import Checkbox from "@mui/material/Checkbox";
import PlusSign from "../../../../../assets/onBoarding/plusSign";
import {
  PlusSignArea,
  StyledAddText,
} from "../../../../../components/commonCategories/styles";
import DeleteIcon from "../../../../../assets/preQualifyIcons/deleteIcon";

type SubcontractorInfoSectionProps = {
  esubData: ESubInfo;
  setESubData: (field: string, value: string) => void;
  isMobile: boolean;
  handleNext: (
    handleGenericGenerate: () => void,
    getPDF: () => void,
    data: any
  ) => void;
  panel: number;
  setPanel: (panel: number) => void;
  setIsLastPanel: (isLastPanel: boolean) => void;
  setPreviousStepPanel: (prevStepPanel: number) => void;
};

export const SubcontractorInfoSection = ({
  esubData,
  setESubData,
  isMobile,
  handleNext,
  panel,
  setPanel,
  setIsLastPanel,
  setPreviousStepPanel,
}: SubcontractorInfoSectionProps) => {
  const [subcontractors, setSubcontractors] = useState<Subcontractor[]>([
    {
      name: "",
      amount: "",
      requiresSubBond: false,
    },
  ]);

  const formatNumberWithCommas = (value: string): string => {
    if (!value) return "";
    
    const cleanValue = value.replace(/[^\d.]/g, "");
    
    if (cleanValue.includes(".")) {
      const [wholePart, decimalPart] = cleanValue.split(".");
      const formattedWhole = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return `${formattedWhole}.${decimalPart}`;
    }
    
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const removeCommas = (value: string): string => {
    return value.replace(/,/g, "");
  };

  const handleAddSubcontractor = () => {
    setSubcontractors([
      ...subcontractors,
      {
        name: "",
        amount: "",
        requiresSubBond: false,
      },
    ]);
  };

  const handleUpdateSubcontractor = (index, value) => {
    setSubcontractors((subcontractor: Subcontractor[]) => {
      return subcontractor.map((s: Subcontractor, i) => {
        if (index === i) {
          return {
            ...s,
            amount: value,
          };
        }

        return s;
      });
    });
  };

  const handleUpdateSubcontractorName = (index, value) => {
    setSubcontractors((subcontractor: Subcontractor[]) => {
      return subcontractor.map((s: Subcontractor, i) => {
        if (index === i) {
          return {
            ...s,
            name: value,
          };
        }

        return s;
      });
    });
  };

  const handleCheckboxChange = (index: number, checked: boolean) => {
    setSubcontractors((prev) =>
      prev.map((sub, i) =>
        i === index ? { ...sub, requiresSubBond: checked } : sub,
      ),
    );
  };

  const handleDeleteSubcontractor = (index: number) => {
    setSubcontractors((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <StyledQuestion isMobile={isMobile} width="650px">
        What is the Subcontractor Info?
      </StyledQuestion>

      {subcontractors.map((sub: Subcontractor, index) => {
        return (
          <Row key={index}>
            <Input
              label="Subcontractor Name"
              type="text"
              fontSize="18px"
              labelSize="12px"
              value={subcontractors[index].name ?? ""}
              setValue={(e) => {
                setSubcontractors((prev) =>
                  prev.map((sub, i) =>
                    i === index ? { ...sub, name: e } : sub,
                  ),
                );
              }}
              backgroundColor={undefined}
              color={undefined}
              placeholder={undefined}
              validateFunc={undefined}
              style={undefined}
              withoutMargin={undefined}
              marginTop={undefined}
              id={undefined}
              labelWeight={undefined}
              textAreaHeight={undefined}
              borderColor={undefined}
              autoComplete={undefined}
              noCheckIcon={undefined}
              cancelIcon={undefined}
              noErrorBorder={undefined}
              ref={undefined}
              hasError={undefined}
              inputId={undefined}
              disabled={undefined}
              width={undefined}
              paddingRight={undefined}
              paddingLeft={undefined}
              onBlur={undefined}
              showError={undefined}
              readOnly={undefined}
              marginRight={undefined}
            />
            <Input
              label="Amount"
              type="text"
              fontSize="18px"
              labelSize="12px"
              value={formatNumberWithCommas(subcontractors[index].amount ?? "")}
              setValue={(e) => {
                setSubcontractors((prev) =>
                  prev.map((sub, i) =>
                    i === index ? { ...sub, amount: removeCommas(e) } : sub,
                  ),
                );
              }}
              backgroundColor={undefined}
              color={undefined}
              placeholder={undefined}
              validateFunc={undefined}
              style={undefined}
              withoutMargin={undefined}
              marginTop={undefined}
              id={undefined}
              labelWeight={undefined}
              textAreaHeight={undefined}
              borderColor={undefined}
              autoComplete={undefined}
              noCheckIcon={undefined}
              cancelIcon={undefined}
              noErrorBorder={undefined}
              ref={undefined}
              hasError={undefined}
              inputId={undefined}
              disabled={undefined}
              width={undefined}
              paddingRight={undefined}
              paddingLeft={undefined}
              onBlur={undefined}
              showError={undefined}
              readOnly={undefined}
              marginRight={undefined}
            />
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
                paddingTop: "50px",
              }}
            >
              <span style={{ fontSize: "12px", color: "#666" }}>
                Requires Sub Bond?
              </span>
              <div
                style={{
                  borderRadius: "4px",
                  padding: "4px",
                  transition: "background-color 0.2s ease",
                }}
              >
                <Checkbox
                  checked={sub.requiresSubBond}
                  onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                  sx={{
                    '&.Mui-checked': {
                      color: '#fff',
                      '& .MuiSvgIcon-root': {
                        backgroundColor: '#FF6D1D',
                        borderRadius: '2px',
                      },
                    },
                    '& .MuiSvgIcon-root': {
                      fontSize: 20,
                    },
                  }}
                />
              </div>
            </div>
            {subcontractors.length > 1 && (
              <DeleteRowButton onClick={() => handleDeleteSubcontractor(index)}>
                <DeleteIcon />
              </DeleteRowButton>
            )}
          </Row>
        );
      })}
      <PlusSignArea usePlusIcon>
        <>
          <div style={{ marginTop: "14px", marginRight: "10px" }}>
            <PlusSign onAdd={handleAddSubcontractor} enableAdd />
          </div>
          <StyledAddText onClick={handleAddSubcontractor} enableAdd>
            Add Subcontractor
          </StyledAddText>
        </>
      </PlusSignArea>
      <FunctionalButton
        buttonTitle="Next"
        handleButton={() => {
          setESubData(
            'bond_details.subcontractors',
            JSON.stringify(subcontractors)
          );
      
          handleNext(
            undefined,
            undefined,
            { bond_details: { subcontractors } }   
          );
          setPanel(8);
        }}
        width={undefined}
        height={undefined}
        isReversedColor={undefined}
        marginRight={undefined}
        marginLeft={undefined}
        marginTop={"40px"}
        marginBottom={undefined}
        fontSize={undefined}
        disabled={undefined}
        icon={undefined}
        hasBoxShadow={undefined}
        frontIcon={undefined}
        weight={undefined}
        borderColor={undefined}
        selected={undefined}
      />
    </>
  );
};
